import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { MenuCreateTitlePage } from '../../../menu/menu-create/menu-create-title/menu-create-title';

@Component({
  selector: 'page-tutorial-menus-combos',
  templateUrl: 'tutorial-menus-combos.html',
})
export class TutorialMenusCombosPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public menuServices: MenuServices) {

  }

  close() {
    /*this.dishServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_menu': true,
    }).then(() => {
      this.navCtrl.pop();
    });*/
    this.navCtrl.pop();
  }

  createMenu() {
    var max_menus = this.menuServices.menus_array.length;
    if (max_menus >= this.globals.checkLimitsByLicense('daily_menu', 'limit') && this.globals.checkLimitsByLicense('daily_menu', 'limit') != -1) { //Si hay limite de menus
      this.navCtrl.pop();
    } else {
      this.globals.tourLaunchStep(2);
      this.navCtrl.push(MenuCreateTitlePage, {
        update_state: false,
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/help/tutorials/tutorial-menus-combos/tutorial-menus-combos.ts